const seo = {
  pages: {
    home: {
      title: "Elite Dental Solutions | Dental Clinic",
      description:
        "Modern dental clinic with an experienced team and a patient-first approach. Book a free consultation and receive a personalised treatment plan.",
    },
    prices: {
      title: "Prices | Elite Dental Solutions",
      description:
        "View our indicative prices for dental services. Contact us for a personalised plan and an exact quote based on your needs.",
    },
    "request-quote": {
      title: "Free Consultation | Elite Dental Solutions",
      description:
        "Submit an inquiry and book a free consultation. Our team will contact you as soon as possible to confirm the details.",
    },
    "privacy-policy": {
      title: "Privacy Policy | Elite Dental Solutions",
      description:
        "Learn how Elite Dental Solutions collects, uses, and protects personal data, and how you can exercise your privacy rights.",
    },
    "terms-of-service": {
      title: "Terms of Service | Elite Dental Solutions",
      description:
        "Read the Terms of Service for Elite Dental Solutions, including appointments, payments, responsibilities, and website use conditions.",
    },
    "not-found": {
      title: "404 | Elite Dental Solutions",
      description: "Page not found.",
    },
    services: {
      implantology: {
        title: "Implantology | Elite Dental Solutions",
        description:
          "High-quality dental implants with precise planning and modern materials. Restore function and confidence with a long-term solution.",
      },
      endodontics: {
        title: "Endodontics | Elite Dental Solutions",
        description:
          "Root canal treatment with modern techniques and careful attention to detail. Relieve pain and preserve your natural tooth.",
      },
      "oral-surgery": {
        title: "Oral Surgery | Elite Dental Solutions",
        description:
          "Oral surgery procedures delivered by an experienced team with a safety-first approach. Consultation, plan, and follow-up care.",
      },
      periodontology: {
        title: "Periodontology | Elite Dental Solutions",
        description:
          "Gum care and periodontal treatment focused on long-term oral health. Diagnosis, therapy, and prevention for healthy gums.",
      },
      orthodontics: {
        title: "Orthodontics | Elite Dental Solutions",
        description:
          "Orthodontic care for aligned teeth and a balanced bite. Individualised treatment planning and progress tracking.",
      },
      bonding: {
        title: "Bonding | Elite Dental Solutions",
        description:
          "Cosmetic bonding to correct small imperfections in shape and colour. A conservative way to enhance your smile.",
      },
      prosthetics: {
        title: "Prosthetics | Elite Dental Solutions",
        description:
          "Prosthetic solutions including crowns, bridges, and dentures for comfort and a natural look. Precision fit and durable results.",
      },
      "lip-filler": {
        title: "Lip Filler | Elite Dental Solutions",
        description:
          "Lip filler treatments with a natural-looking result and careful attention to facial proportions. Consultation and tailored approach.",
      },
      cariesology: {
        title: "Cariesology | Elite Dental Solutions",
        description:
          "Caries diagnosis and treatment using gentle techniques and quality materials. Protect tooth structure and restore aesthetics.",
      },
      "teeth-whitening": {
        title: "Teeth Whitening | Elite Dental Solutions",
        description:
          "Professional teeth whitening in-clinic or at home. Safe protocols and visible results for a brighter smile.",
      },
      "dental-tourism": {
        title: "Dental Tourism | Elite Dental Solutions",
        description:
          "Dental tourism in Bulgaria with end-to-end coordination and high-quality care. Get a plan, quote, and support for your visit.",
      },
    },
  },
};

export default seo;

